import * as React from "react";
import { Routes, Route } from "react-router-dom";
import AppLayout from "../AppLayout";
import AdminDashboard from "../Admin/Dashboard";
import HrAttendance from "../AttendanceComponent";
import AttendanceTable from "../AttendanceTable";
import StudentList from "../StudentList";
import CourseCard from "../CourseCard";
import EnquiryManagement from "../EnquiryManagement";
import AdminCourseCreation from "../Admin/AdminCouseCreation";
import AdminExpenseDashboard from "../Admin/AdminExpenseDashboard";
import ViewFeesComponent from "../ViewFeesComponent";
import FeeHistory from "../FeeHistory";
import BatchCreationDialog from "../BatchCreationDialog";
import AddExpenseForm from "../Admin/AddExpense";
import AttendanceHistory from "../AttendanceHistory";
import StudentProfile from "../StudentProfile";
import Error404 from "../Error404";
import ExpensePage from "../Admin/ExpensePage";
import UpdatedCourse from "../Admin/UpdateCourse";
import HrList from "../Admin/HrList";
import InstructorStaff from "../Admin/InstructorStaff";

export default function adminRoutes() {
  return (
    <Routes>
      {/* Layout Route for Admin */}
      <Route path="/" element={<AppLayout />}>
        {/* Nested Routes for Admin Dashboard */}
        <Route index element={<AdminDashboard />} />
        <Route path="/:username" element={<StudentProfile />} />
        <Route path="attendance" element={<HrAttendance />} />
        <Route path="attendance/:id" element={<AttendanceTable />} />
        <Route path="attendancehistory/:id" element={<AttendanceHistory />} />
        <Route path="view-fee" element={<ViewFeesComponent />} />
        <Route path="feehistory/:id" element={<FeeHistory />} />
        <Route path="batch" element={<BatchCreationDialog />} />
        <Route path="courses" element={<CourseCard />} />
        <Route path="courses/:coursename" element={<StudentList />} />
        <Route path="add-course" element={<AdminCourseCreation />} />
        <Route path="update-course/:id" element={<UpdatedCourse />} />
        <Route path="enquiry" element={<EnquiryManagement />} />
        <Route path="students" element={<StudentList />} />
        <Route path="expenses" element={<AdminExpenseDashboard />} />
        <Route path="expenses/:category" element={<ExpensePage />} />
        <Route path="add-expanse" element={<AddExpenseForm />} />
        <Route path="register" element={<HrList />} />
        <Route path="instructorStaff" element={<InstructorStaff />} />
        <Route path="*" element={<Error404 />} />
      </Route>
    </Routes>
  );
}
